import { render, staticRenderFns } from "./bindRobot.vue?vue&type=template&id=5dfde6d0&"
import script from "./bindRobot.vue?vue&type=script&lang=ts&"
export * from "./bindRobot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports